<div class="d-flex" id="wrapper">

    <admin-sidebar id="admin-sidebar"></admin-sidebar>

    <div id="page-content-wrapper">

      <admin-navigation></admin-navigation>

        <div class="container-fluid">

          <div class="row mt-4 mt-md-4 mb-4 mb-md-4">
            <div class="col-md-6 redirect-link">
              <i class="fa fa-angle-left align-middle"></i>
              <a [routerLink]="['/admin/series']" class="pl-2 pl-md-2 align-middle">All Series & Modules</a>
            </div>
            <div class="col-md-6">
                <div class="series-status-container pull-right align-middle">
                  <label class="switch" for="checkbox">
                      <span
                        class="series-status"
                        [ngClass]="{'published': (seriesStatusText === 'Published'), 'not-published': (seriesStatusText !== 'Published')}"
                      >
                        {{ seriesStatusText }}
                      </span>
                      <input type="checkbox" id="checkbox" [(ngModel)]="isPublished" (change)="changeSeriesStatus(isPublished)">
                      <div class="slider round"></div>
                    </label>
                </div>
              <button
                type="submit"
                class="btn btn-primary pull-right add-button"
                form="ngForm"
              >
                Save
              </button>
            </div>
          </div>

          <!-- Success Submit Message -->
          <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="submitSuccess">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="submitSuccess = !submitSuccess">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
            </button>
            {{ modalMessage }}
          </div>

          <!-- Error Submit Message -->
          <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="submitError">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="submitError = !submitError">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
            </button>
            An error occurred when submitting form data.
          </div>

          <!-- Error Change Series Status Message -->
          <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="changeSeriesStatusError">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="changeSeriesStatusError = !changeSeriesStatusError">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
            </button>
            Series need to have at all 3 modules in order to be published
          </div>

          <div class="module-details-container" id="module-details-container">

            <div class="row">
              <div class="col-md-12">
                <h3 class="d-inline-block font-weight-bold page-title">{{ series?.title }}</h3>
              </div>
            </div>
            <!-- Show if no modules created -->
            <div *ngIf="modules?.length == 0">
                <label for="">No Modules created.</label>
            </div>

          <div class="row mt-md-4 mt-4">
              <div class="col-md-12">
                <button
                  type="button"
                  *ngFor="let data of modules"
                  [routerLink]="['/admin/series/' + seriesId + '/' + data?.details.sequence_number ]" role="button"
                  class="btn btn-primary module-button"
                  [ngClass]="{'not-active': data.details.sequence_number != sequenceNo}"
                  [disabled]="addNewModule"
                >
                    {{ 'Module ' + data?.details.sequence_number }}
              </button>
                <button
                  type="button"
                  class="btn btn-primary module-cancel-button pull-right mr-md-3 mr-3"
                  [ngClass]="{'pull-right': modules?.length > 0 && modules?.length < 3}"
                  (click)="loadData(); showAddModuleButton = !showAddModuleButton; addNewModule = !addNewModule"
                  *ngIf="!showAddModuleButton && modules"
                >
                  <i class="fa fa-close"></i> Cancel
                </button>
                <button
                  type="button"
                  class="btn btn-primary module-button pull-right mr-md-3 mr-3"
                  [ngClass]="{'pull-right': modules?.length > 0 && modules?.length < 3}"
                  (click)="addBlankModule(); showAddModuleButton = !showAddModuleButton"
                  *ngIf="showAddModuleButton && modules && modules?.length < 3"
                >
                  + Add Module
                </button>
              </div>
          </div>
          <div class="module-container" *ngIf="modules && modules?.length > 0">
              <!-- Details -->
              <form [formGroup]="moduleForm" (ngSubmit)="onSubmit()" id="ngForm">
                <div class="row mt-md-5 mt-5">
                  <div class="col-md-11 col-lg-11 module-details">
                    <h3 class="d-inline-block font-weight-bold page-title">Details</h3>
                    <div class="md-input">
                      <input
                        class="md-form-control"
                        required
                        type="text"
                        formControlName="moduleName"
                        maxlength="35"
                        #moduleName
                        [ngClass]="{'error': (submitted && moduleForm.invalid && f.moduleName.invalid) || (f.moduleName.dirty && f.moduleName.invalid)}"
                      >
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>Name</label>
                    </div>
                    <div class="text-length-indicator">
                      <span>{{ moduleName.value.length + '/35' }}</span>
                    </div>

                    <div class="md-input">
                      <textarea
                        class="md-form-control" rows="2"
                        required
                        maxlength="100"
                        formControlName="moduleDescription"
                        #moduleDescription
                        [ngClass]="{'error': (submitted && moduleForm.invalid && f.moduleDescription.invalid) || (f.moduleDescription.dirty && f.moduleDescription.invalid)}"
                      >
                      </textarea>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>Description</label>
                    </div>
                    <div class="text-length-indicator">
                      <span>{{ moduleDescription.value.length + '/100' }}</span>
                    </div>

                    <!-- Image -->
                    <div id="image-container">
                      <div class="row">
                        <div class="col-md-12">
                          <h3 class="font-weight-bold page-title">Image
                            <button
                              type="button"
                              class="btn btn-danger btn-sm pull-right"
                              *ngIf="moduleDetails.details?.cover_url !== '' && imageSourcePreview !== ''"
                              (click)="deleteImageUpload()"
                            >
                              <i class="fa fa-trash"></i> Delete Upload
                            </button>
                          </h3>
                        </div>
                      </div>

                      <label
                        class="font-weight-bold text-center align-middle imageInputLabel"
                        for="imageFileInput"
                      >
                        {{ imageUploadLabel }}
                      </label>

                      <!-- Image Error Message -->
                      <p class="text-danger" *ngIf="imageError">Image Cover is required!</p>

                      <input
                          type="file"
                          class="ml-md-3 ml-3 file-input"
                          accept=".jpg, .png, .jpeg, .gif|image/*"
                          (change)="onImageFileInputChange($event)"
                          #imageFileInput
                          id="imageFileInput"
                      >
                      <img [src]="imageSourcePreview" *ngIf="imageSourcePreview" class="img-fluid mt-4 mt-md-4">
                      <img [src]="moduleDetails.details?.cover_url" *ngIf="imageSourcePreview == ''" class="img-fluid mt-4 mt-md-4">
                    </div>
                    <!-- End of Image -->

                    <!-- Color -->
                    <div class="row">
                      <div class="col-md-4 mt-md-3 mt-3">
                        <label for="colorSelect">Color</label>
                        <input
                          readonly
                          id="colorSelect"
                          class="form-control"
                          [(colorPicker)]="coverColor"
                          [style.background]="coverColor"
                          (colorPickerChange)="getCoverColor(coverColor)"
                          [cpAlphaChannel]="'disabled'"
                        />
                      </div>
                    </div>
                    <!-- End of Color -->

                  </div>
                </div>
              </form>

              <!-- End of Details -->

              <!-- Videos -->
              <div class="row mt-md-5 mt-5">
                <div class="col-md-11 col-lg-11 module-details" id="video-container">
                  <div class="row">
                    <div class="col-md-12">
                      <h3 class="font-weight-bold page-title">Video
                        <button
                          type="button"
                          class="btn btn-danger btn-sm pull-right"
                          *ngIf="moduleDetails.details?.video_url !== '' && videoSourcePreview.length > 0"
                          (click)="deleteVideoUpload()"
                        >
                          <i class="fa fa-trash"></i> Delete Upload
                        </button>
                      </h3>
                    </div>
                  </div>
                  <label
                    class="font-weight-bold text-center align-middle videoInputLabel mb-4 mb-md-4"
                    for="videoFileInput"
                  >
                    {{ videoUploadLabel }}
                  </label>

                  <!-- Video Error Message -->
                  <p class="text-danger" *ngIf="videoError">{{ videoErrorMsg }}</p>

                  <input
                      type="file"
                      class="ml-md-3 ml-3 file-input"
                      accept=".mp4, .mov|video/*"
                      (change)="onVideoFileInputChange($event)"
                      #videoFileInput
                      id="videoFileInput"
                  >

                  <!-- New Module Video -->
                  <div
                    plyr
                    [plyrOptions]="{hideControls: false}"
                    [plyrPlaysInline]="true"
                    [plyrSources]="videoSourcePreview"
                    (plyrInit)="videoPlayer = $event"
                    style="height: 100%;padding-top: 0px;"
                    *ngIf="videoSourcePreview.length > 0"
                  >
                  </div>
                  <!-- End of New Module Video -->

                  <!-- Existing Module Video -->
                  <div
                    plyr
                    [plyrPlaysInline]="true"
                    [plyrSources]="moduleDetails.details?.video_url"
                    (plyrInit)="videoPlayer = $event"
                    *ngIf="moduleDetails.details?.video_url !== '' && videoSourcePreview.length == 0"
                  >
                  </div>
                  <!-- End of Existing Module Video -->

                </div>
              </div>
              <!-- End of Videos -->

              <!-- Quiz -->
              <div class="row mt-md-5 mt-5">
                <div class="col-md-11 col-lg-11 module-details">
                  <div class="row">
                    <div class="col-md-12 d-flex align-middle">
                      <h3 class="font-weight-bold page-title">Quiz </h3>
                      <i class="fa fa-info-circle pull-right tooltip-helper" placement="right" ngbTooltip="You can re-arrange the order of the question answers by holding the left mouse key then drag and drop."></i>
                    </div>
                  </div>

                  <div *ngFor="let question of questions; let questionIndex = index" [id]="'question' + '_' + questionIndex + '_' + seriesId">
                    <div class="row mt-4 mt-md-4">
                      <div class="col-md-6">
                        <h5 class="font-weight-bold align-middle page-title">{{ 'Question ' + (questionIndex + 1) }}</h5>
                      </div>
                      <div class="col-md-6">
                        <span class="pull-right align-middle delete-question" (click)="deleteQuestion(questionIndex)"><i
                            class="fa fa-trash"></i> Delete Question</span>
                      </div>
                    </div>
                    <!-- <div class="md-input">
                      <input
                        class="md-form-control"
                        required
                        type="text"
                        [(ngModel)]="question.question"
                      >
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>Question</label>
                    </div> -->

                    <div class="question-tiny-mce-container mt-5 mt-md-5">
                      <label>Question</label>
                      <editor
                          plugins="paste"
                          [inline]="true"
                          toolbar="undo redo | italic"
                          [init]="{
                              forced_root_block : '',
                              force_br_newlines : true,
                              force_p_newlines : false,
                              height: 150,
                              menubar: false,
                              branding: false,
                              base_url: '/tinymce',
                              suffix: '.min',
                              content_style: '.mce-content-body { box-shadow: none; outline: none; font-weight: 800; }'
                          }"
                          [(ngModel)]="question.question"
                          (onFocusOut)="onFocusOutQuestion($event, questionIndex)"
                          (onFocus)="onFocusQuestion($event, questionIndex)"
                          class="question-tiny-mce"
                          [id]="'question_tiny_mce_' + questionIndex"
                      >
                      </editor>
                    </div>

                    <!-- Sortable Answers -->
                    <div [sortablejs]="question.answers">
                      <!-- <div class="md-input" *ngFor="let answer of question.answers; let answerIndex = index">
                        <textarea class="md-form-control text-area-answers" rows="1" required [(ngModel)]="answer.answer"></textarea>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="text-success" *ngIf="answer.correct == 1">Correct Answer</label>
                        <label class="text-danger" *ngIf="answer.correct == 0">Incorrect Answer</label>
                        <span
                          class="delete-icon"
                          *ngIf="incorrectAnswers[questionIndex] != answerIndex && answer.correct == 0"
                          (click)="deleteAnswer(questionIndex, answerIndex)"
                        >
                          <i class="fa fa-trash"></i> Delete
                        </span>
                      </div> -->

                      <div class="answer-tiny-mce-container my-5 my-md-5" *ngFor="let answer of question.answers; let answerIndex = index">
                        <label class="text-success" *ngIf="answer.correct == 1">Correct Answer</label>
                        <label class="text-danger" *ngIf="answer.correct == 0">Incorrect Answer</label>
                        <span
                          class="delete-icon"
                          *ngIf="incorrectAnswers[questionIndex] != answerIndex && answer.correct == 0"
                          (click)="deleteAnswer(questionIndex, answerIndex)"
                        >
                          <i class="fa fa-trash"></i> Delete
                        </span>
                        <editor
                            plugins="paste"
                            [inline]="true"
                            toolbar="undo redo | italic"
                            [init]="{
                                height: 150,
                                menubar: false,
                                branding: false,
                                base_url: '/tinymce',
                                suffix: '.min',
                                force_p_newlines : false,
                                forced_root_block : '',
                                content_style: '.mce-content-body { box-shadow: none; outline: none; font-weight: 800; }'
                            }"
                            [(ngModel)]="answer.answer"
                            (onFocusOut)="onFocusOutAnswer($event, questionIndex, answerIndex)"
                            (onFocus)="onFocusAnswer($event, questionIndex, answerIndex)"
                            class="answer-tiny-mce"
                            [id]="'answer_tiny_mce_' + questionIndex + '_' + answerIndex"
                        >
                        </editor>
                      </div>

                    </div>

                    <button type="button" class="btn btn-primary module-button-white not-active add-answer mb-4 mb-md-4"
                      (click)="addAnswer(questionIndex)">
                      + Add Answer
                    </button>
                  </div>

                  <button type="button" class="btn btn-primary add-button add-question mt-3 mt-md-3" (click)="addQuestion()">
                    + Add Question
                  </button>
                </div>
              </div>
              <!-- End of Quiz -->

              <!-- Summary -->
              <div class="row mt-md-5 mt-5 mb-md-5 mb-5">
                <div class="col-md-11 col-lg-11 module-details">
                  <div class="row">
                    <div class="col-md-12 d-flex align-middle">
                      <h3 class="font-weight-bold page-title">Summary </h3>
                      <i class="fa fa-info-circle pull-right tooltip-helper" placement="right" ngbTooltip="You can re-arrange the order of the summary items by holding the left mouse key then drag and drop."></i>
                    </div>
                  </div>

                  <!-- Sortable Summaries -->
                  <div [sortablejs]="summaries">
                    <div class="md-input" *ngFor="let summary of summaries; let i = index" [id]="'summary_' + i + '_' + seriesId">
                      <textarea class="md-form-control text-area-summary" rows="3" required [(ngModel)]="summary.text"></textarea>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <span
                        class="delete-icon-summary"
                        (click)="deleteSummary(i)"
                      >
                        <i class="fa fa-trash"></i> Delete
                      </span>
                      <label>Summary point</label>
                    </div>
                  </div>

                  <button type="button" class="btn btn-primary module-button-white not-active" (click)="addSummary()">+ Add Summary
                    Point</button>
                </div>
              </div>
              <!-- End of Summary -->
            </div>
          </div>

        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

    </div>

  </div>
